import { translate } from '@vimeo/i18n-runtime';

export const editAlbum = translate('Edit');
export const loadMore = translate('Load more');
export const noVideos = translate('No videos');
export const share = translate('Share');
export const videoCount = (count: number) => {
  if (count === 0) {
    return noVideos;
  }

  return translate({
    count,
    singular: '{COUNT} video',
    plural: '{COUNT} videos',
    replacements: { COUNT: count },
  });
};

export const viewDescription = translate('View description');
export const next = translate('Next');
